<script lang="ts">
	import DirectusPostGrid from '#lib/directus/components/Directus_postGrid.svelte';
	import type { PostGrid } from '#lib/schema-extension.js';

	const { data, params } = $props();

	const season = $derived(data.season);

	const postGrid: PostGrid = $derived({
		title: 'Blog',
		wildcats: !!params.wildcats,
		seasons: [season.id!!]
	});
</script>

<DirectusPostGrid block={postGrid} />
